import type { FetchResponse, RequestParams } from 'services/fetch';
import fetch from 'services/fetch';

import type { GetAppConfigResponse } from './data-contracts';

/**
 * No description
*
 * @tags Application_config
 * @name AppConfigDetail
 * @summary Get application config
 * @request GET:/v1/app-config/{platform}
 * @secure
 * @response `200` `GetAppConfigResponse`
 * @response `403` `{
    errors?: ({
  \** @example "d6a6cd3e6d3e22148ff37a8059421b17" *\
    correlationId?: string,
  \** @example "403" *\
    status?: string,
  \** @example "Forbidden" *\
    title?: string,
  \** @example 1002 *\
    code?: number,
  \** @example "Insufficient permissions" *\
    details?: string,

})[],

}` Forbidden error message

*/
export const appConfigDetail = (
  platform: 'ios' | 'android' | 'web',
  params: RequestParams = {}
): FetchResponse<GetAppConfigResponse> => {
  return fetch<GetAppConfigResponse>(`/v1/app-config/${platform}`, {
    method: 'GET',
    ...params,
  });
};
